document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.npbp-bundle-product');
    sections.forEach(function (section) {
        const bundleStates = new WeakMap();

        // Swiper logic
        function getSwiperSlidesPerView(activeSlideCount, defaultValue) {
            if (activeSlideCount <= 1) {
                return 1;
            }

            return Math.min(activeSlideCount, defaultValue);
        }

        function initBundleSwiper(targetSection, activeSlideCount) {
            const container = targetSection.querySelector('.nbp-bundle-product__content-swiper');
            if (!container) return null;
            const scrollbarEl = container.querySelector('.nbp-bundle-product__swiper-scrollbar');
            const prevEl = container.querySelector('.nbp-bundle-product__swiper-button-prev');
            const nextEl = container.querySelector('.nbp-bundle-product__swiper-button-next');
            const visibleSlideCount = Math.max(Number(activeSlideCount) || 0, 1);
            if (container.swiper && typeof container.swiper.destroy === 'function') {
                container.swiper.destroy(true, true);
            }
            const instance = new Swiper(container, {
                slidesPerView: getSwiperSlidesPerView(visibleSlideCount, 4),
                spaceBetween: 16,
                breakpoints: {
                    0: {
                        slidesPerView: visibleSlideCount === 1 ? 1 : 1.1,
                        spaceBetween: 12,
                    },
                    500: {
                        slidesPerView: getSwiperSlidesPerView(visibleSlideCount, 1.6),
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: getSwiperSlidesPerView(visibleSlideCount, 2.1),
                        spaceBetween: 16,
                    },
                    1140: {
                        slidesPerView: getSwiperSlidesPerView(visibleSlideCount, 2.6),
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: getSwiperSlidesPerView(visibleSlideCount, 4),
                        spaceBetween: 16,
                    },
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                },
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                },
                watchOverflow: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
            });
            container.swiper = instance;
            return instance;
        }

        /* == Bundle product interaction logic == */
        function formatMoney(cents) {
            const amount = Number(cents) || 0;
            if (
                window.theme &&
                theme.Currency &&
                typeof theme.Currency.formatMoney === 'function' &&
                theme.moneyFormat
            ) {
                return theme.Currency.formatMoney(amount, theme.moneyFormat);
            }
            return (amount / 100).toFixed(2);
        }

        function normalizeQty(value) {
            const qty = Number(value);
            if (!Number.isFinite(qty)) return 0;
            return Math.max(0, Math.min(999, Math.floor(qty)));
        }

        function getBlockState(block) {
            let state = bundleStates.get(block);
            if (state) return state;
            state = {
                main: {
                    variantId: Number(block.dataset.mainVariantId) || 0,
                    title: block.dataset.mainVariantTitle || '',
                    price: Number(block.dataset.mainPrice) || 0,
                    compareAtPrice: Number(block.dataset.mainCompareAtPrice) || 0,
                    available: block.dataset.mainAvailable === 'true',
                },
                selections: {},
            };
            bundleStates.set(block, state);
            return state;
        }

        function getAccordionSelection(block, accordion) {
            const state = getBlockState(block);
            const key = accordion.dataset.accordionIndex;
            return state.selections[key] || null;
        }

        function setAccordionSelection(block, accordion, button, quantity) {
            const state = getBlockState(block);
            const key = accordion.dataset.accordionIndex;
            state.selections[key] = {
                variantId: Number(button.dataset.variantId) || 0,
                title: button.dataset.variantTitle || button.textContent.trim(),
                price: Number(button.dataset.variantPrice) || 0,
                compareAtPrice: Number(button.dataset.variantCompareAtPrice) || 0,
                available: button.dataset.variantAvailable === 'true',
                quantity: normalizeQty(quantity),
                data: Object.assign({}, button.dataset),
            };
            return state.selections[key];
        }

        function setPriceContent(priceEl, compareEl, price, compareAtPrice) {
            if (priceEl) {
                priceEl.textContent = formatMoney(price);
            }
            if (compareEl) {
                compareEl.textContent = formatMoney(compareAtPrice);
                compareEl.hidden = compareAtPrice <= price || compareAtPrice <= 0;
            }
        }

        function renderAccordionPrice(block, accordion) {
            const selection = getAccordionSelection(block, accordion);
            const input = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');
            const regularPriceEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-regular-price');
            const oldPriceEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-old-price');
            const quantity = normalizeQty(input ? input.value : 0);
            const basePrice = selection ? selection.price : Number(accordion.dataset.accordionProductPrice) || 0;
            const baseCompareAtPrice = selection ? selection.compareAtPrice : Number(accordion.dataset.accordionProductCompareAtPrice) || 0;
            setPriceContent(regularPriceEl, oldPriceEl, basePrice * quantity, baseCompareAtPrice * quantity);
        }

        function renderFooterPrice(block) {
            const state = getBlockState(block);
            const totalPriceEls = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-total-origal-price');
            const totalOldPriceEls = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-total-old-price');
            const totalSavedPriceEls = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-total-saved-price');
            const totalSavedLabelEls = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-total-label');
            let totalPrice = state.main.price;
            let totalCompareAtPrice = state.main.compareAtPrice;

            Object.keys(state.selections).forEach(key => {
                const item = state.selections[key];
                const quantity = normalizeQty(item.quantity);
                if (quantity <= 0) return;
                totalPrice += item.price * quantity;
                totalCompareAtPrice += item.compareAtPrice * quantity;
            });

            totalPriceEls.forEach(function (totalPriceEl, index) {
                setPriceContent(totalPriceEl, totalOldPriceEls[index], totalPrice, totalCompareAtPrice);
            });

            totalSavedPriceEls.forEach(function (totalSavedPriceEl) {
                totalSavedPriceEl.textContent = formatMoney(Math.max(totalCompareAtPrice - totalPrice, 0));
            });
            totalSavedLabelEls.forEach(function (totalSavedLabelEl) {
                totalSavedLabelEl.hidden = totalCompareAtPrice <= totalPrice;
            });
        }

        function showBlockInfo(block, message) {
            const infoEls = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-info');
            if (!infoEls.length) return;
            infoEls.forEach(function (infoEl) {
                infoEl.textContent = message || '';
                infoEl.hidden = !message;
            });
        }

        function buildUnavailableMessage(template, title) {
            if (!template) {
                return title + ' is unavailable.';
            }
            if (template.indexOf('[variant]') !== -1) {
                return template.replace(/\[variant\]/g, title);
            }
            return title + ' ' + template;
        }

        function syncBlockPrices(block) {
            const accordions = block.querySelectorAll('.nbp-bundle-product-block__content-accordion');
            accordions.forEach(accordion => {
                renderAccordionPrice(block, accordion);
            });
            renderFooterPrice(block);
        }

        function handleVariantSelect(block, accordion, button) {
            const variantButtons = accordion.querySelectorAll('.nbp-bundle-product-block__content-accordion-variant-item-button');
            const quantityInput = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');

            variantButtons.forEach(item => item.classList.remove('active'));
            button.classList.add('active');

            if (quantityInput) {
                quantityInput.value = 1;
            }

            setAccordionSelection(block, accordion, button, 1);
            showBlockInfo(block, '');
            renderAccordionPrice(block, accordion);
            renderFooterPrice(block);
        }

        function clearAccordionSelection(block, accordion) {
            const state = getBlockState(block);
            const key = accordion.dataset.accordionIndex;
            const quantityInput = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');
            const variantButtons = accordion.querySelectorAll('.nbp-bundle-product-block__content-accordion-variant-item-button');

            variantButtons.forEach(item => item.classList.remove('active'));
            delete state.selections[key];

            if (quantityInput) {
                quantityInput.value = 0;
            }
        }

        function updateAccordionQuantity(block, accordion, nextQty) {
            const quantityInput = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');
            const selection = getAccordionSelection(block, accordion);
            const quantity = normalizeQty(nextQty);

            if (!selection) {
                if (quantityInput) {
                    quantityInput.value = 0;
                }
                renderAccordionPrice(block, accordion);
                renderFooterPrice(block);
                return;
            }

            if (quantity <= 0) {
                clearAccordionSelection(block, accordion);
                renderAccordionPrice(block, accordion);
                renderFooterPrice(block);
                return;
            }

            if (quantityInput) {
                quantityInput.value = quantity;
            }
            selection.quantity = quantity;

            renderAccordionPrice(block, accordion);
            renderFooterPrice(block);
        }

        function collectCartItems(block) {
            const state = getBlockState(block);
            const items = [];
            const invalidItems = [];

            if (state.main.variantId > 0 && state.main.available) {
                items.push({
                    id: state.main.variantId,
                    quantity: 1,
                });
            } else {
                invalidItems.push(state.main.title || 'Main product');
            }

            Object.keys(state.selections).forEach(key => {
                const item = state.selections[key];
                const quantity = normalizeQty(item.quantity);

                if (quantity <= 0 || !item.variantId) return;
                if (!item.available) {
                    invalidItems.push(item.title || 'Variant');
                    return;
                }

                items.push({
                    id: item.variantId,
                    quantity: quantity,
                });
            });

            return {
                items: items,
                invalidItems: invalidItems,
            };
        }

        function showInvalidItems(block, invalidItems) {
            const template = block.dataset.unavailableText || '';
            const message = invalidItems.map(title => buildUnavailableMessage(template, title)).join(' ');
            showBlockInfo(block, message);
        }

        function initDefaultAccordionSelections(block) {
            const accordions = block.querySelectorAll('.nbp-bundle-product-block__content-accordion');

            accordions.forEach(accordion => {
                const inputEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');
                const variantButtons = accordion.querySelectorAll('.nbp-bundle-product-block__content-accordion-variant-item-button');
                const defaultQty = normalizeQty(inputEl ? inputEl.value : 0);

                if (!variantButtons.length) return;

                if (defaultQty > 0) {
                    const defaultButton = accordion.querySelector('.nbp-bundle-product-block__content-accordion-variant-item-button.active') || variantButtons[0];
                    variantButtons.forEach(item => item.classList.remove('active'));
                    defaultButton.classList.add('active');
                    setAccordionSelection(block, accordion, defaultButton, defaultQty);

                    if (inputEl) {
                        inputEl.value = defaultQty;
                    }
                    return;
                }

                clearAccordionSelection(block, accordion);
            });
        }

        function bindVariantButtons(block) {
            const accordions = block.querySelectorAll('.nbp-bundle-product-block__content-accordion');
            accordions.forEach(accordion => {
                const variantButtons = accordion.querySelectorAll('.nbp-bundle-product-block__content-accordion-variant-item-button');
                variantButtons.forEach(button => {
                    button.addEventListener('click', function () {
                        handleVariantSelect(block, accordion, button);
                    });
                });
            });
        }

        function bindQuantityControls(block) {
            const accordions = block.querySelectorAll('.nbp-bundle-product-block__content-accordion');
            accordions.forEach(accordion => {
                const minusEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-minus');
                const plusEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-plus');
                const inputEl = accordion.querySelector('.nbp-bundle-product-block__content-accordion-product-qty-input .number');

                if (!minusEl || !plusEl || !inputEl) return;

                minusEl.addEventListener('click', function () {
                    updateAccordionQuantity(block, accordion, normalizeQty(inputEl.value) - 1);
                });

                plusEl.addEventListener('click', function () {
                    updateAccordionQuantity(block, accordion, normalizeQty(inputEl.value) + 1);
                });

                inputEl.addEventListener('input', function () {
                    updateAccordionQuantity(block, accordion, inputEl.value);
                });

                inputEl.addEventListener('blur', function () {
                    updateAccordionQuantity(block, accordion, inputEl.value);
                });
            });
        }

        function bindBuyNow(block) {
            const buyNowButtons = block.querySelectorAll('.nbp-bundle-product-block__content-accordion-footer-buy-now-button');
            if (!buyNowButtons.length) return;

            buyNowButtons.forEach(function (buyNowButton) {
                buyNowButton.addEventListener('click', function () {
                    const cartPayload = collectCartItems(block);

                    showBlockInfo(block, '');

                    if (cartPayload.invalidItems.length) {
                        showInvalidItems(block, cartPayload.invalidItems);
                        return;
                    }

                    if (!cartPayload.items.length) {
                        return;
                    }

                    buyNowButtons.forEach(function (button) {
                        button.disabled = true;
                        button.classList.add('is-loading');
                        const buttonLoader = button.querySelector('.loader');
                        if (buttonLoader) {
                            buttonLoader.classList.remove('hide');
                        }
                    });

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: JSON.stringify({
                            items: cartPayload.items,
                        }),
                    })
                        .then(function (response) {
                            return response.json().then(function (data) {
                                if (!response.ok || data.status) {
                                    throw new Error(data.description || data.message || 'Cart error');
                                }
                                return data;
                            });
                        })
                        .then(function () {
                            if (
                                window.theme &&
                                theme.Cart &&
                                theme.Cart.prototype &&
                                typeof theme.Cart.prototype._onProductAdded === 'function'
                            ) {
                                theme.Cart.prototype._onProductAdded();
                                return;
                            }
                            window.location.href = '/cart';
                        })
                        .catch(function (error) {
                            showBlockInfo(block, error.message || 'Cart error');
                        })
                        .finally(function () {
                            buyNowButtons.forEach(function (button) {
                                button.disabled = false;
                                button.classList.remove('is-loading');
                                const buttonLoader = button.querySelector('.loader');
                                if (buttonLoader) {
                                    buttonLoader.classList.add('hide');
                                }
                            });
                        });
                });
            });
        }

        function initBundleBlock(block) {
            getBlockState(block);
            initDefaultAccordionSelections(block);
            syncBlockPrices(block);
            bindVariantButtons(block);
            bindQuantityControls(block);
            bindBuyNow(block);
        }
        /* == Bundle product interaction logic == */

        // Tab change logic
        function updateTabContents(section, contents, activeTabId, id) {
            const contentRoot = section.querySelector('.nbp-bundle-product__content');
            const contentSwiper = section.querySelector('.nbp-bundle-product__content-swiper');
            const activeContents = [];

            if (!contentRoot || !contentSwiper) {
                return [];
            }

            contentRoot.classList.remove('one-column', 'two-column', 'three-column');

            contents.forEach(contentItem => {
                const isMatched = contentItem.getAttribute(id) === activeTabId;

                contentItem.classList.toggle('active', isMatched);
                contentItem.hidden = !isMatched;

                if (isMatched) {
                    contentItem.classList.add('swiper-slide');
                    activeContents.push(contentItem);
                } else {
                    contentItem.classList.remove('swiper-slide');
                }
            });

            if (activeContents.length === 1) {
                contentRoot.classList.add('one-column');
            } else if (activeContents.length === 2) {
                contentRoot.classList.add('two-column');
            } else if (activeContents.length === 3) {
                contentRoot.classList.add('three-column');
            }

            if (!activeContents.length) {
                if (contentSwiper.swiper && typeof contentSwiper.swiper.destroy === 'function') {
                    contentSwiper.swiper.destroy(true, true);
                }
                return activeContents;
            }

            const bundleSwiper = initBundleSwiper(section, activeContents.length);
            if (bundleSwiper) {
                bundleSwiper.update();
                bundleSwiper.slideTo(0, 0, false);
            }

            return activeContents;
        }

        function updateActiveTabMaxSlideHeight(section, activeTabId) {
            const slides = section.querySelectorAll(`.nbp-bundle-product__content:not(.one-column) .nbp-bundle-product__content-swiper-slide[data-tab="${activeTabId}"]`);
            let maxH = 0;
            slides.forEach(slide => {
                if (slide.hidden) return;
                const h = slide.offsetHeight || slide.getBoundingClientRect().height || slide.scrollHeight || 0;
                if (h > maxH) maxH = h;
            });
            if (maxH > 0) {
                section.style.setProperty('--npbp-tab-max-slide-height', maxH + 'px');
            } else {
                section.style.removeProperty('--npbp-tab-max-slide-height');
            }
        }

        function updateActiveTabMaxSlideHeightAsync(section, activeTabId) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => updateActiveTabMaxSlideHeight(section, activeTabId));
            });
        }

        function tabChange(section, tabEls, contentEls, id) {   
            const tabs = section.querySelectorAll(tabEls);
            const contents = Array.from(section.querySelectorAll(contentEls));
            if (!tabs.length || !contents.length) return;

            const firstTabId = tabs[0].getAttribute(id);
            tabs[0].classList.add('active');
            updateTabContents(section, contents, firstTabId, id);
            setAccordionWrapperHeightAsync();
            alignProductCardInfoHeightAsync();
            updateActiveTabMaxSlideHeightAsync(section, firstTabId);

            tabs.forEach(tabItem => {     
                tabItem.addEventListener('click', function () {
                    tabs.forEach(t => t.classList.remove('active'));
                    tabItem.classList.add('active');
                    const currentId = tabItem.getAttribute(id);
                    updateTabContents(section, contents, currentId, id);

                    setAccordionWrapperHeightAsync();
                    alignProductCardInfoHeightAsync();
                    updateActiveTabMaxSlideHeightAsync(section, currentId);
                });
            });
        }

        // Accordion logic
        const accordionTriggers = section.querySelectorAll('.nbp-bundle-product-block__content-accordion-trigger');
        accordionTriggers.forEach(trigger => {
            trigger.addEventListener('click', function () {
                trigger.parentElement.toggleAttribute('open');
                setAccordionWrapperHeightAsync();
            });
        });

        tabChange(section, '.npbp-bundle-product__tab-button', '.nbp-bundle-product__content-swiper-slide', 'data-tab');

        // Align product card info height logic
        function alignProductCardInfoHeight() {
            const activeCards = section.querySelectorAll('.nbp-bundle-product__content-swiper-slide.active');
            const root = section.querySelector('.nbp-bundle-product__content') || section;
            let maxH = 0;

            if (!activeCards.length) {
                root.style.removeProperty('--max-prod-head-height');
                return;
            }

            activeCards.forEach(cards => {
                const root = cards.closest('.nbp-bundle-product__content') || section;
                root.style.setProperty('--max-prod-info-height', 'auto');
            });

            activeCards.forEach(card => {
                const productIntros = card.querySelectorAll('.nbp-bundle-product-block__content-head');
                if (!productIntros.length) return;

                productIntros.forEach(el => {
                    const h = el.offsetHeight || el.getBoundingClientRect().height || el.scrollHeight;
                    if (h > maxH) maxH = h;
                });
            });

            root.style.setProperty('--max-prod-head-height', maxH + 'px');
        }

        function alignProductCardInfoHeightAsync() {
            requestAnimationFrame(() => {
                requestAnimationFrame(alignProductCardInfoHeight);
            });
        }

        function setAccordionWrapperHeight() {
            const accordionWrappers = section.querySelectorAll('.nbp-bundle-product-block__top');

            accordionWrappers.forEach(wrapper => {
                const wrapperHeight = wrapper.offsetHeight || wrapper.getBoundingClientRect().height || wrapper.scrollHeight || 0;
                wrapper.style.setProperty('--nbp-bundle-product-block-height', `${wrapperHeight}px`);
            });
        }

        function setAccordionWrapperHeightAsync() {
            requestAnimationFrame(() => {
                requestAnimationFrame(setAccordionWrapperHeight);
            });
        }

        // Click tab scroll into center logic
        function bindScrollIntoCenter(section, scrollerSelector, triggerSelector) {
            const scroller = section.querySelector(scrollerSelector);
            if (!scroller) return;
            const triggers = section.querySelectorAll(triggerSelector);
            if (!triggers.length) return;
            if(window.innerWidth >= 769) return;
            
            function center(tab) {
                requestAnimationFrame(() => {
                    const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
                    const scrollerCenter = scroller.clientWidth / 2;

                    scroller.scrollTo({
                        left: tabCenter - scrollerCenter,
                        behavior: 'smooth'
                    });
                });
            }

            triggers.forEach(tabEl => {
                tabEl.addEventListener('click', () => center(tabEl));
            });
        }

        const bundleBlocks = section.querySelectorAll('.nbp-bundle-product__block');
        bundleBlocks.forEach(block => {
            initBundleBlock(block);
        });

        setAccordionWrapperHeightAsync();
        alignProductCardInfoHeightAsync();

        bindScrollIntoCenter(section, '.npbp-bundle-product__tabs', '.npbp-bundle-product__tab-button');

    });
});
